<template>
  <div class="sidebar-items-wrapper">
    <ul class="sidenav-items" style="height: calc(100vh - 10rem); overflow-y: scroll">
      <sidebar-item title="Dashboard" url="/3pl/dashboard">
        <template v-slot:icon>
          <home-svg />
        </template>
      </sidebar-item>
      <sidebar-item title="Terminals" url="/settings/terminals">
        <template v-slot:icon>
          <location-svg />
        </template>
      </sidebar-item>
      <sidebar-item title="Routes" url="/settings/routes">
        <template v-slot:icon>
          <routes-svg />
        </template>
      </sidebar-item>
      <sidebar-item title="Fleets" url="/settings/vehicles">
        <template v-slot:icon>
          <fleets-svg />
        </template>
      </sidebar-item>

      <sidebar-item v-if="userAccountType != 'solo_operator' && $_isAdmin" title="Roles & Privileges"
        url="/settings/roles-and-privileges">
        <template v-slot:icon>
          <users-svg />
        </template>
      </sidebar-item>

      <sidebar-item v-if="userAccountType != 'solo_operator' && $_isAdmin" title="Users"
        url="/settings/users-and-groups">
        <template v-slot:icon>
          <users-svg />
        </template>
      </sidebar-item>

      <sidebar-item-dropdown title="Booking & Shipments" url="/3pl/dashboard">
        <template v-slot:icon>
          <operations-svg />
        </template>
        <template v-slot:children>
          <router-link :to="{ name: 'BookingsHome' }">
            <span class="pr-2">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M19.993 5.94998C19.9914 5.87778 19.9817 5.80599 19.964 5.73598C19.957 5.71098 19.943 5.68698 19.934 5.66198C19.913 5.60498 19.894 5.54898 19.864 5.49698C19.848 5.46998 19.826 5.44798 19.807 5.42198C19.775 5.37698 19.744 5.33098 19.705 5.29198C19.682 5.26998 19.652 5.25198 19.627 5.23098C19.588 5.19898 19.552 5.16398 19.507 5.13698C19.503 5.13398 19.498 5.13398 19.493 5.13098L19.485 5.12498L10.506 0.134977C10.3576 0.0527039 10.1908 0.00945278 10.0211 0.00927788C9.85147 0.00910297 9.68454 0.0520101 9.536 0.133977L0.515 5.12398C0.512 5.12698 0.509 5.13098 0.504 5.13398L0.494 5.13798C0.459 5.15798 0.433 5.18698 0.4 5.21098C0.364 5.23798 0.326 5.26198 0.294 5.29298C0.264 5.32398 0.241 5.35998 0.215 5.39498C0.188 5.42998 0.158 5.46098 0.136 5.49898C0.11 5.54198 0.0959999 5.59098 0.0769999 5.63798C0.0629999 5.67098 0.045 5.70198 0.036 5.73798C0.0187295 5.80672 0.00900528 5.87713 0.00699997 5.94798C0.00599997 5.96498 0 5.97998 0 5.99798V14C0 14.363 0.197 14.698 0.515 14.874L9.493 19.861L9.494 19.862L9.496 19.863L9.516 19.874C9.559 19.898 9.606 19.911 9.651 19.928C9.683 19.941 9.714 19.958 9.748 19.967C9.91395 20.0098 10.088 20.0098 10.254 19.967C10.287 19.958 10.318 19.941 10.351 19.928C10.396 19.911 10.443 19.899 10.486 19.874L10.506 19.863L10.508 19.862L10.509 19.861L19.487 14.874C19.803 14.698 20 14.363 20 14V5.99798C20 5.98098 19.994 5.96698 19.993 5.94998ZM9.972 9.87198L3.058 6.00498L5.82 4.47698L12.654 8.38198L9.972 9.87198ZM10.02 2.15298L16.941 5.99998L14.697 7.24698L7.867 3.34398L10.02 2.15298ZM11 17.301L11.002 11.622L14 9.94398V13L16 12V8.82498L18 7.70598V13.411L11 17.301Z"
                  fill="#B7BDCD" />
              </svg>
            </span>
            <span v-show="!isSideNavCollapsed">Booking</span>
          </router-link>

          <router-link to="/operations/consolidation">
            <span class="pr-2"><svg width="19" height="22" viewBox="0 0 22 22" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21.3532 11.5068L16.7332 9.38018V3.28685C16.7311 3.15901 16.6923 3.03448 16.6214 2.9281C16.5504 2.82171 16.4504 2.73797 16.3332 2.68685L11.3332 0.386846C11.2455 0.346232 11.1499 0.325195 11.0532 0.325195C10.9565 0.325195 10.861 0.346232 10.7732 0.386846L5.77324 2.68685C5.65752 2.7404 5.55958 2.82602 5.49105 2.93355C5.42251 3.04107 5.38626 3.166 5.38657 3.29351V9.38685L0.786571 11.5068C0.670851 11.5604 0.572917 11.646 0.504383 11.7535C0.435848 11.8611 0.399589 11.986 0.399904 12.1135V18.6335C0.399589 18.761 0.435848 18.886 0.504383 18.9935C0.572917 19.101 0.670851 19.1866 0.786571 19.2402L5.78657 21.5402C5.87433 21.5808 5.96987 21.6018 6.06657 21.6018C6.16327 21.6018 6.25881 21.5808 6.34657 21.5402L11.0666 19.3668L15.7866 21.5402C15.8743 21.5808 15.9699 21.6018 16.0666 21.6018C16.1633 21.6018 16.2588 21.5808 16.3466 21.5402L21.3466 19.2402C21.4623 19.1866 21.5602 19.101 21.6288 18.9935C21.6973 18.886 21.7336 18.761 21.7332 18.6335V12.1135C21.7341 11.9867 21.6989 11.8623 21.6316 11.7549C21.5643 11.6474 21.4677 11.5614 21.3532 11.5068ZM16.0732 13.6668L12.6666 12.1135L16.0732 10.5468L19.4799 12.1135L16.0732 13.6668ZM15.4066 9.37352L11.1132 11.3735V6.24685C11.1936 6.24329 11.2726 6.22522 11.3466 6.19351L15.3999 4.33351V9.38685L15.4066 9.37352ZM11.0666 1.72018L14.4732 3.28685L11.0666 4.85351L7.66657 3.28685L11.0666 1.72018ZM6.06657 10.5402L9.47324 12.1068L6.06657 13.6668L2.6599 12.1135L6.06657 10.5402ZM10.3999 18.2002L6.06657 20.2002V15.0735C6.15961 15.068 6.25045 15.043 6.33324 15.0002L10.3866 13.1335L10.3999 18.2002ZM20.3999 18.2002L16.0932 20.2002V15.0735C16.1772 15.0645 16.2586 15.0396 16.3332 15.0002L20.3866 13.1335L20.3999 18.2002Z"
                  fill="#B7BDCD" />
              </svg>
            </span>
            <span v-show="!isSideNavCollapsed">Consolidation</span>
          </router-link>
          <router-link to="/operations/dispatch"><span class="pr-2"><svg width="19" height="18" viewBox="0 0 25 18"
                fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.3333 0.333496L9.75 4.71016V13.2902L17.3333 17.6668L24.9167 13.2902V4.71016L17.3333 0.333496ZM17.3333 2.836L21.45 5.2085L17.3333 7.58099L13.2275 5.2085L17.3333 2.836ZM0 3.5835V5.75016H7.58333V3.5835H0ZM11.9167 6.95266L16.25 9.45516V14.536L11.9167 12.0443V6.95266ZM22.75 6.95266V12.0443L18.4167 14.536V9.45516L22.75 6.95266ZM2.16667 7.91683V10.0835H7.58333V7.91683H2.16667ZM4.33333 12.2502V14.4168H7.58333V12.2502"
                  fill="#B7BDCD" />
              </svg>
            </span>
            <span v-show="!isSideNavCollapsed">Dispatch </span>
          </router-link>
          <router-link to="/operations/hand-off"><span class="pr-2">
              <template >
                <handoff-svg />
              </template>
            </span>
            <span v-show="!isSideNavCollapsed">Hand-off </span>
          </router-link>
          <router-link v-if="$store.state.authentication.env == 'development'" to="/settings/trackings"><span
              class="pr-2"><svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.0001 8.1665H11.3501C11.0001 7.19984 10.0834 6.49984 9.00008 6.49984C7.91675 6.49984 7.00008 7.19984 6.65008 8.1665H4.00008C3.72508 8.1665 2.33341 8.08317 2.33341 6.49984V5.6665C2.33341 4.1415 3.61675 3.99984 4.00008 3.99984H12.4834C12.8334 4.9665 13.7501 5.6665 14.8334 5.6665C15.4965 5.6665 16.1323 5.40311 16.6012 4.93427C17.07 4.46543 17.3334 3.82955 17.3334 3.1665C17.3334 2.50346 17.07 1.86758 16.6012 1.39874C16.1323 0.929896 15.4965 0.666504 14.8334 0.666504C13.7501 0.666504 12.8334 1.3665 12.4834 2.33317H4.00008C2.65841 2.33317 0.666748 3.2165 0.666748 5.6665V6.49984C0.666748 8.94984 2.65841 9.83317 4.00008 9.83317H6.65008C7.00008 10.7998 7.91675 11.4998 9.00008 11.4998C10.0834 11.4998 11.0001 10.7998 11.3501 9.83317H14.0001C14.2751 9.83317 15.6667 9.9165 15.6667 11.4998V12.3332C15.6667 13.8582 14.3834 13.9998 14.0001 13.9998H5.51675C5.16675 13.0332 4.25008 12.3332 3.16675 12.3332C2.50371 12.3332 1.86782 12.5966 1.39898 13.0654C0.93014 13.5342 0.666748 14.1701 0.666748 14.8332C0.666748 15.4962 0.93014 16.1321 1.39898 16.6009C1.86782 17.0698 2.50371 17.3332 3.16675 17.3332C4.25008 17.3332 5.16675 16.6332 5.51675 15.6665H14.0001C15.3417 15.6665 17.3334 14.7748 17.3334 12.3332V11.4998C17.3334 9.05817 15.3417 8.1665 14.0001 8.1665ZM14.8334 2.33317C15.0544 2.33317 15.2664 2.42097 15.4227 2.57725C15.579 2.73353 15.6667 2.94549 15.6667 3.1665C15.6667 3.38752 15.579 3.59948 15.4227 3.75576C15.2664 3.91204 15.0544 3.99984 14.8334 3.99984C14.6124 3.99984 14.4004 3.91204 14.2442 3.75576C14.0879 3.59948 14.0001 3.38752 14.0001 3.1665C14.0001 2.94549 14.0879 2.73353 14.2442 2.57725C14.4004 2.42097 14.6124 2.33317 14.8334 2.33317ZM3.16675 15.6665C2.94573 15.6665 2.73377 15.5787 2.57749 15.4224C2.42121 15.2661 2.33341 15.0542 2.33341 14.8332C2.33341 14.6122 2.42121 14.4002 2.57749 14.2439C2.73377 14.0876 2.94573 13.9998 3.16675 13.9998C3.38776 13.9998 3.59972 14.0876 3.756 14.2439C3.91228 14.4002 4.00008 14.6122 4.00008 14.8332C4.00008 15.0542 3.91228 15.2661 3.756 15.4224C3.59972 15.5787 3.38776 15.6665 3.16675 15.6665Z"
                  fill="#B7BDCD" />
              </svg>
            </span>
            <span v-show="!isSideNavCollapsed">Tracking </span>
          </router-link>

          <router-link v-if="$store.state.authentication.env == 'development'"
            :to="{ name: 'IncidentAndRequest' }"><span class="pr-2"><svg width="18" height="18" viewBox="0 0 18 18"
                fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.0001 8.1665H11.3501C11.0001 7.19984 10.0834 6.49984 9.00008 6.49984C7.91675 6.49984 7.00008 7.19984 6.65008 8.1665H4.00008C3.72508 8.1665 2.33341 8.08317 2.33341 6.49984V5.6665C2.33341 4.1415 3.61675 3.99984 4.00008 3.99984H12.4834C12.8334 4.9665 13.7501 5.6665 14.8334 5.6665C15.4965 5.6665 16.1323 5.40311 16.6012 4.93427C17.07 4.46543 17.3334 3.82955 17.3334 3.1665C17.3334 2.50346 17.07 1.86758 16.6012 1.39874C16.1323 0.929896 15.4965 0.666504 14.8334 0.666504C13.7501 0.666504 12.8334 1.3665 12.4834 2.33317H4.00008C2.65841 2.33317 0.666748 3.2165 0.666748 5.6665V6.49984C0.666748 8.94984 2.65841 9.83317 4.00008 9.83317H6.65008C7.00008 10.7998 7.91675 11.4998 9.00008 11.4998C10.0834 11.4998 11.0001 10.7998 11.3501 9.83317H14.0001C14.2751 9.83317 15.6667 9.9165 15.6667 11.4998V12.3332C15.6667 13.8582 14.3834 13.9998 14.0001 13.9998H5.51675C5.16675 13.0332 4.25008 12.3332 3.16675 12.3332C2.50371 12.3332 1.86782 12.5966 1.39898 13.0654C0.93014 13.5342 0.666748 14.1701 0.666748 14.8332C0.666748 15.4962 0.93014 16.1321 1.39898 16.6009C1.86782 17.0698 2.50371 17.3332 3.16675 17.3332C4.25008 17.3332 5.16675 16.6332 5.51675 15.6665H14.0001C15.3417 15.6665 17.3334 14.7748 17.3334 12.3332V11.4998C17.3334 9.05817 15.3417 8.1665 14.0001 8.1665ZM14.8334 2.33317C15.0544 2.33317 15.2664 2.42097 15.4227 2.57725C15.579 2.73353 15.6667 2.94549 15.6667 3.1665C15.6667 3.38752 15.579 3.59948 15.4227 3.75576C15.2664 3.91204 15.0544 3.99984 14.8334 3.99984C14.6124 3.99984 14.4004 3.91204 14.2442 3.75576C14.0879 3.59948 14.0001 3.38752 14.0001 3.1665C14.0001 2.94549 14.0879 2.73353 14.2442 2.57725C14.4004 2.42097 14.6124 2.33317 14.8334 2.33317ZM3.16675 15.6665C2.94573 15.6665 2.73377 15.5787 2.57749 15.4224C2.42121 15.2661 2.33341 15.0542 2.33341 14.8332C2.33341 14.6122 2.42121 14.4002 2.57749 14.2439C2.73377 14.0876 2.94573 13.9998 3.16675 13.9998C3.38776 13.9998 3.59972 14.0876 3.756 14.2439C3.91228 14.4002 4.00008 14.6122 4.00008 14.8332C4.00008 15.0542 3.91228 15.2661 3.756 15.4224C3.59972 15.5787 3.38776 15.6665 3.16675 15.6665Z"
                  fill="#B7BDCD" />
              </svg>
            </span>
            <span v-show="!isSideNavCollapsed">Incident & Request </span>
          </router-link>
        </template>
      </sidebar-item-dropdown>

      <sidebar-item-dropdown v-if="$_isAdmin" title="Billings & Payments">
        <template v-slot:icon>
          <billing-svg />
        </template>
        <template v-slot:children>
          <router-link class="flex items-center" :to="{ name: 'BCM_overview' }">
            <span class="pr-2">
              <img class="w-4" src="./svgs/overview.svg" alt="customer registration svg" />
            </span>
            <span v-show="!isSideNavCollapsed">Overview</span>
          </router-link>
          <router-link class="flex items-center" :to="{ name: 'BCM_alltransaction' }">
            <span class="pr-2"><img class="w-4" src="./svgs/billings.svg" alt="customer registration svg" />
            </span>
            <span v-show="!isSideNavCollapsed">Billings</span>
          </router-link>
          <!-- <router-link class="flex items-center" :to="{ name: 'BCM_estimate' }"
            ><span class="pr-2">
              <img src="./svgs/Estimate.svg" class="w-4" alt="customer engagement svg" />
            </span>
            <span v-show="!isSideNavCollapsed">Estimates</span>
          </router-link> -->

          <!-- <router-link class="flex items-center" :to="{ name: 'BCM_recievables' }"><span class="pr-2">
            <img src="./svgs/recievables.svg" class="w-4" alt="customer engagement svg" />
          </span>
          <span v-show="!isSideNavCollapsed">Receivables</span>
        </router-link> -->

          <!-- <router-link class="flex items-center" :to="{ name: 'BCM_collections' }"
            ><span class="pr-2">
              <img
                src="./svgs/collection.svg"
                class="w-5"
                alt="customer engagement svg"
              />
            </span>
            <span v-show="!isSideNavCollapsed">Payments</span>
          </router-link> -->
          <!-- <router-link class="flex items-center" :to="{ name: 'BCM_settlements' }"
            ><span class="pr-2">
              <img
                src="./svgs/settlement.svg"
                class="w-4"
                alt="customer engagement svg"
              />
            </span>
            <span v-show="!isSideNavCollapsed">Settlements</span>
          </router-link> -->
          <router-link class="flex items-center relative" :to="{ name: 'EarningAndPayout' }"><span class="pr-2">
              <img src="./svgs/earn_payment.svg" class="w-4" alt="customer engagement svg" />
            </span>
            <span v-show="!isSideNavCollapsed">Earnings & Payouts</span>
            <!-- <div class="tooltip-box">
              <p>New</p>
            </div> -->
          </router-link>

          <!-- <router-link v-if="$_isDevelopment" class="flex items-center" :to="{ name: 'EarnAndPayout' }"
          ><span class="pr-2">
            <img
              src="./svgs/earn_payment.svg"
              class="w-4"
              alt="customer engagement svg"
            />
          </span>
          <span v-show="!isSideNavCollapsed">Earn & Payout</span>
        </router-link> -->
        </template>
      </sidebar-item-dropdown>

      <sidebar-item-dropdown v-if="$store.state.authentication.env == 'development' && $_isAdmin" title="Accounting">
        <template v-slot:icon>
          <billing-svg />
        </template>
        <template v-slot:children>
          <router-link class="flex items-center" :to="{ name: 'ChartAccount3PL' }">
            <span class="pr-2"><img class="w-4" src="./svgs/account_chart.svg" alt="customer registration svg" />
            </span>
            <span v-show="!isSideNavCollapsed">Chart of Accounts</span>
          </router-link>
          <router-link class="flex items-center" :to="{ name: 'BCM_alltransaction' }">
            <span class="pr-2"><img class="w-4" src="./svgs/account_revenue.svg" alt="customer registration svg" />
            </span>
            <span v-show="!isSideNavCollapsed">Revenue Tracking</span>
          </router-link>
          <router-link class="flex items-center" :to="{ name: 'ExpenditureTracking' }"><span class="pr-2">
              <img src="./svgs/account_expenditure.svg" class="w-4" alt="customer engagement svg" />
            </span>
            <span v-show="!isSideNavCollapsed">Expenditure Tracking</span>
          </router-link>

          <!-- <router-link class="flex items-center" :to="{ name: 'BCM_recievables' }"><span class="pr-2">
            <img src="./svgs/recievables.svg" class="w-4" alt="customer engagement svg" />
          </span>
          <span v-show="!isSideNavCollapsed">Receivables</span>
        </router-link> -->

          <router-link class="flex items-center" :to="{ name: 'AccountingSales' }"><span class="pr-2">
              <img src="./svgs/account_sales.svg" class="w-5" alt="customer engagement svg" />
            </span>
            <span v-show="!isSideNavCollapsed">Sales Margin</span>
          </router-link>
          <router-link class="flex items-center" :to="{ name: 'AccountingTax' }"><span class="pr-2">
              <img src="./svgs/account_tax.svg" class="w-4" alt="customer engagement svg" />
            </span>
            <span v-show="!isSideNavCollapsed">Tax</span>
          </router-link>
          <router-link class="flex items-center" :to="{ name: 'AccountingCreditDebit' }"><span class="pr-2">
              <img src="./svgs/account_credit.svg" class="w-4" alt="customer engagement svg" />
            </span>
            <span v-show="!isSideNavCollapsed">Credits and Debits </span>
          </router-link>
        </template>
      </sidebar-item-dropdown>

      <sidebar-item-dropdown v-if="$store.state.authentication.env == 'development' && $_isAdmin" title="Customers">
        <template v-slot:icon>
          <customers-svg />
        </template>
        <template v-slot:children>
          <router-link class="flex items-center" :to="{ name: 'CRM' }">
            <span class="pr-2"><img src="./svgs/CustomerRegistration.svg" alt="customer registration svg" />
            </span>
            <span v-show="!isSideNavCollapsed">Customer Registration</span>
          </router-link>
          <router-link class="flex items-center" :to="{ name: 'CustomerEngagement' }"><span class="pr-2">
              <img src="./svgs/CustomerEngagement.svg" alt="customer engagement svg" />
            </span>
            <span v-show="!isSideNavCollapsed">Customer Engagement</span>
          </router-link>
        </template>
      </sidebar-item-dropdown>

      <sidebar-item-dropdown hidden title="Billing & Payment">
        <template v-slot:icon>
          <billing-svg />
        </template>
        <template v-slot:children>
          <router-link class="flex items-center" :to="{ name: 'BillingAndPayments' }">
            <span class="pr-2">
              <img src="./svgs/overview.svg" alt="Overview svg" />
            </span>
            <span v-show="!isSideNavCollapsed">Overview </span>
          </router-link>
          <router-link class="flex items-center" :to="{ name: 'BillingPayments' }">
            <span class="pr-2">
              <img src="./svgs/payments.svg" alt="Overview svg" />
            </span>
            <span v-show="!isSideNavCollapsed">Payments </span>
          </router-link>
        </template>
      </sidebar-item-dropdown>
    </ul>
    <div class="w-full flex justify-center">
      <button @click="moveToDashboard">
        <MuleexLogo color="rgba(255,255,255,0.7)" />
      </button>
    </div>
  </div>
</template>

<script>
import SidebarItem from "./SidebarItem";
import SidebarItemDropdown from "./SidebarItemDropdown";
import HomeSvg from "./svgs/HomeSvg";
import LocationSvg from "./svgs/LocationSvg";
import FleetsSvg from "./svgs/FleetsSvg";
import UsersSvg from "./svgs/UsersSvg";
import RoutesSvg from "./svgs/RoutesSvg";
import MuleexLogo from "../navbar/MuleexLogo.vue";
// import BillingCollection from "./svgs/BillingCollection.vue";

import CustomersSvg from "./svgs/CustomersSvg";
import BillingSvg from "./svgs/BillingSvg";
import HandoffSvg from "./svgs/HandoffSvg";
import OperationsSvg from "./svgs/OperationsSvg";
export default {
  components: {
    HandoffSvg,
    SidebarItem,
    SidebarItemDropdown,
    HomeSvg,
    LocationSvg,
    FleetsSvg,
    UsersSvg,
    RoutesSvg,
    CustomersSvg,
    BillingSvg,
    OperationsSvg,
    MuleexLogo,
    // BillingCollection,
  },
  data() {
    return {
      showTerminalChildren: false,
    };
  },
  computed: {
    isSideNavCollapsed() {
      return this.$store.getters.isSideNavCollapsed;
    },
    userDetails() {
      return this.$store.state.authentication.user;
    },
    isEnterpriseCustomer() {
      return this.userDetails.accounttype == "individual" &&
        this.userDetails.onboardingtype == "organization"
        ? true
        : false;
    },
    userAccountType() {
      return this.$store.state.authentication.accountUserType;
    },
  },
  methods: {
    moveToDashboard() {
      const onboardingType = JSON.parse(localStorage.getItem('loggedInUser'))

      switch (onboardingType.onboardingtype) {
        case 'ondemand':
          this.$router.push('/dashboard')
          break;

        case "3PL":
          this.$router.push('/3pl/dashboard')
          break;
      }
    },
    async logout() {
      try {
        localStorage.clear();
        this.$router.push({ name: "Login" });
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sidenav-items {
  margin-top: 3rem;
  flex: 1
}

.sidenav-items::-webkit-scrollbar {
  width: 0.5rem;
}

.sidenav-items::-webkit-scrollbar-thumb {
  background-color: #2e3c52;
  border-radius: 5px;
}

.muleex-logo {
  padding-top: 1.5rem;
  padding-left: 3rem;
}

svg {
  display: inline-block;
}

.tooltip-box {
  // display: none;
  position: absolute;
  bottom: 55%;
  left: 210px;
  width: 40px;
  height: 16px;
  background-color: #FFFFFF;
  color: #F0F4FE;
  padding: 0;
  border-radius: 8px;
  z-index: 999;
  font-size: 13px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
}


.tooltip-box p {
  text-align: center;
  // color: #FCC210;
  color: #10233e;

  font-weight: 700;
  margin: 0 0 10px;
  font-size: 12px;
  line-height: 1.4;
}
</style>
